// @ts-nocheck
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import Icon, { IconProps } from "@insite/mobius/Icon";
import DollarSign from "@insite/mobius/Icons/DollarSign";
import Barrel from "@store/Library/Components/Icons/Barrel";
import Leaf from "@store/Library/Components/Icons/Leaf";
import * as React from "react";

interface OwnProps {
    type: string;
    extendedStyles?: AlternativeIconStyles;
}

export interface AlternativeIconStyles {
    icon?: IconProps;
}

const alternativeIconStyles: AlternativeIconStyles = {};

const AlternativeIcon = ({ type, extendedStyles }: OwnProps) => {
    const [styles] = React.useState(() => mergeToNew(alternativeIconStyles, extendedStyles));

    switch (type) {
        case "Cost":
            return <Icon src={DollarSign} {...styles.icon} />;
        case "Green":
            return <Icon src={Leaf} {...styles.icon} />;
        case "Sustainability":
            return <Icon src={Leaf} {...styles.icon} />;
        default:
            return <Icon src={Barrel} {...styles.icon} />;
    }
};

export default AlternativeIcon;
